/**
 * SplitPanelContext — lets pages render content into the global AppLayout's
 * SplitPanel without nesting AppLayouts.
 *
 * App.tsx owns the state and passes it to <AppLayout splitPanel=... />.
 * Pages call useSplitPanelControl().setSplitPanel(<SplitPanel .../>) and must
 * clear it (setSplitPanel(null)) on unmount.
 */
import { createContext, useContext, ReactNode } from 'react';

export interface SplitPanelController {
  /** Sets the SplitPanel element to render, or null to remove it. */
  setSplitPanel: (panel: ReactNode | null) => void;
  /** Opens/closes the panel. */
  setSplitPanelOpen: (open: boolean) => void;
}

export const SplitPanelContext = createContext<SplitPanelController | null>(null);

export const useSplitPanelControl = (): SplitPanelController => {
  const controller = useContext(SplitPanelContext);
  if (!controller) {
    throw new Error('useSplitPanelControl must be used within SplitPanelContext.Provider');
  }
  return controller;
};
